import type { StartCallButtonProps } from './StartCallButton.types';
import { CALL_STATE } from 'Constants/enums';

import * as React from 'react';

import { IconButton } from '../shared/IconButton';

export const StartCallButton: React.FC<StartCallButtonProps> = ({
  callState,
  compact,
  conversationId,
  makeCall,
  personPbo,
  phone,
  popupPosition,
  pushToGTMDataLayer,
  size,
  testid,
}) => {
  const placeCall = () => {
    personPbo?.state === 'fulfilled' && personPbo?.value.sourceId
      ? makeCall(Number.parseInt(personPbo?.value.sourceId))
      : makeCall(null, phone);

    pushToGTMDataLayer('placeCall', {
      internalUser: true,
      callDestination:
        personPbo?.state === 'fulfilled' ? personPbo?.value.sourceId : phone,
      conversationId,
    });
  };

  return (
    <IconButton
      disabled={{
        title: 'You are currently on a call with this person',
        condition: callState !== CALL_STATE.Available,
      }}
      content="Start Call"
      onClick={placeCall}
      icon="call"
      testid={`${testid}-buttonStartCall`}
      {...{ size, popupPosition, compact }}
    />
  );
};
